import { Box } from "../mantine-passthroughs/index.js";
import { useIsMobile } from "../../hooks/layout/use-is-mobile.js";
import full_bleed_module_default from "./full-bleed.module.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/full-bleed/FullBleed.tsx
const FullBleed = ({ breakpoint, children, color = "gray", flex = false, spacing = "all", bold = false, border = "none", "data-testid": testId }) => {
	const isMobile = useIsMobile(breakpoint);
	return /* @__PURE__ */ jsx(Box, {
		className: full_bleed_module_default.root,
		"data-color": color,
		"data-active": isMobile || typeof breakpoint === "undefined" ? "true" : "false",
		"data-spacing": spacing,
		"data-full-bleed": "true",
		"data-bold": bold ? "true" : "false",
		"data-border": border,
		"data-testid": testId,
		flex: flex ? "1" : "",
		children
	});
};

//#endregion
export { FullBleed };